export function init_searchBar() {
    const OPEN_BUTTON = document.getElementById('search-btn');
    const CLOSE_BUTTON = document.getElementById('close-search-bar');

    const HEADER_WRAP = document.getElementById('header').firstElementChild;
    const SEARCH_BAR = document.getElementById('search-bar');
    const SEARCH_INPUT = document.getElementById('search-bar-input');
    const SEARCH_RESULTS = document.getElementById('search-bar-results');
    const SEARCH_RESULTS_LIST = document.getElementById('search-bar-results-list');
    const SEARCH_RESULTS_COUNT = document.getElementById('search-bar-results-count');

    let searchAni = new TimelineLite({paused:true});
    let resultsAni = new TimelineLite({paused:true});
    let aResults = [];
    let results = [];


    searchAni.fromTo( HEADER_WRAP, 0.6,
        { y: "0%", }, { y: "100%", ease:Power3.easeInOut })
        .fromTo( SEARCH_BAR, 0.6,
            { y: "-100%", },
            { y: "0%", ease:Power3.easeInOut }, 0, -0.1 );

    searchAni.eventCallback("onComplete", () => {
        SEARCH_INPUT.focus()
    });

    resultsAni.fromTo( SEARCH_RESULTS, 0.6,
        { y: "-100%", }, { y: "0%", ease:Power3.easeInOut });



    if( OPEN_BUTTON ){
        OPEN_BUTTON.addEventListener('click', openSearch);
    }

    if( CLOSE_BUTTON ){
        CLOSE_BUTTON.addEventListener('click', closeSearch);
    }

    if( SEARCH_INPUT ){
        SEARCH_INPUT.addEventListener('input', () =>{
            resultsAni.play().timeScale(1)
        });
    }

    document.addEventListener('keyup', (e) => {
        e = e || window.event;
        getSearchResult(SEARCH_INPUT.value);
        if (e.keyCode == 27) {
            closeSearch();
        }
    });

    function getSearchResult(value) {
        var searchValue = value;
        // console.log('searchvalue:', searchValue)
        var request = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                aResults = JSON.parse(this.responseText);
                results = aResults.data;
                showResults();
                updateNumberOfResults();
            }
        }
        request.open("GET", "/api/search.json?search="+searchValue);
        request.send();
    }

    function showResults() {
        var htmlResults = "";
        for (var i = 0; i < results.length; i++) {
            var htmlResult = '<li>\
                                <a href="' + results[i].url + '">\
                                    <span class="o-text--display">' + results[i].title+ '</span><span> ' + results[i].subtitle+ '</span>\
                                </a>\
                            </li>';
            htmlResults += htmlResult;
        }
        SEARCH_RESULTS_LIST.innerHTML = htmlResults;
    }

    function updateNumberOfResults() {
        var numberOfResults = results.length;
        SEARCH_RESULTS_COUNT.innerHTML = numberOfResults;
    }

    function openSearch () {
        if( SEARCH_BAR ){ searchAni.play().timeScale(1); }
    }
    function closeSearch () {
        if( SEARCH_BAR ){ 
            resultsAni.reverse().timeScale(1)
            searchAni.reverse().timeScale(1.2); 
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/search-bar.js